import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import React from 'react';

const DropTarget = React.forwardRef(
  ({open, isActive, children, sx, ...props}, ref) => {
    return (
      <Backdrop
        ref={ref}
        open={open}
        sx={{
          color: 'common.white',
          zIndex: 'modal',
          '&:before': {
            content: '""',
            border: '2px dashed',
            color: 'common.white',
            outline: 'none',
            position: 'absolute',
            top: theme => theme.spacing(3),
            right: theme => theme.spacing(3),
            bottom: theme => theme.spacing(3),
            left: theme => theme.spacing(3),
          },
          bgcolor: isActive && 'rgba(5,23,25,0.5)',
          ...sx,
        }}
        {...props}
      >
        <Box padding={0.5} textAlign="center">
          {children}
        </Box>
      </Backdrop>
    );
  }
);

DropTarget.propTypes = {
  children: PropTypes.node,
  open: PropTypes.bool,
  isActive: PropTypes.bool,
  sx: PropTypes.object,
};

export default DropTarget;
